var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgG4Hub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 39,
    viewBox: "0 0 116 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.42 0H53.7037C51.7264 0 50.1235 1.71185 50.1235 3.82353V35.1765C50.1235 37.2881 51.7264 39 53.7037 39H112.42C114.397 39 116 37.2881 116 35.1765V3.82353C116 1.71185 114.397 0 112.42 0Z",
    fill: "#9D4EDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30176 25.1009H11.6022V29.0589H3.82635L0.120239 25.1009V13.1972L3.82635 9.23926H6.30176V25.1009ZM9.57433 18.0663H18.0635V29.0589H12.5812V21.9943H9.57433V18.0663ZM7.28076 13.1972V9.23926H14.8188L18.0635 13.1972V15.1837H11.8819V13.1972H7.28076Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0346 22.4275H38.1324V26.2958H36.0346V29.0589H30.0909V9.23926H36.0346V22.4275ZM19.6158 22.6216L29.1119 10.5835V18.4248L25.7414 22.4275H29.1119V26.2958H21.0843L19.6158 22.6216Z",
    fill: "#9D4EDD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2839 28.1986V11.4707H61.7592V18.6398H68.4722V11.4707H72.9475V28.1986H68.4722V21.0295H61.7592V28.1986H57.2839ZM77.4228 28.1986V25.8089H75.1852V16.2501H79.6605V25.8089H86.3734V16.2501H90.8487V28.1986H77.4228ZM95.3241 28.1986V25.8089H93.0864V11.4707H97.5617V16.2501H106.512V18.6398H108.75V25.8089H106.512V28.1986H95.3241ZM97.5617 25.8089H104.275V18.6398H97.5617V25.8089Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgG4Hub);
export default __webpack_public_path__ + "static/media/g4HUB.4ad6e7aa5d0b8ccb32fbffef457fafa6.svg";
export { ForwardRef as ReactComponent };